import { ENTERPRISE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { ANNUAL, MONTHLY } from 'self-service-api/constants/Terms';
/**
 * Sort offers such that lower terms come first
 * at time of writing, this means MCMP, ACMP, ACAP
 */
const offerInfoSortingFuncHelper = (firstInfo, secondInfo) => {
  if (!firstInfo || !secondInfo) return 0;
  if (firstInfo.payment === MONTHLY && secondInfo.payment === ANNUAL || firstInfo.commitment === MONTHLY && secondInfo.commitment === ANNUAL) {
    return -1;
  }
  return 1;
};
export const reducePromotionsResponse = data => {
  if (data && data.productsEligibleForDirectPromotions) {
    const offersMap = Object.keys(data.offersById).reduce((acc, offerId) => {
      const {
        commitmentTerm,
        paymentTerm,
        discount
      } = data.offersById[offerId];
      acc[offerId] = {
        commitment: commitmentTerm.toLowerCase(),
        payment: paymentTerm.toLowerCase(),
        discount
      };
      return acc;
    }, {});
    const getSortedOfferIds = (offerIds = []) => offerIds.sort((firstOfferId, secondOfferId) => {
      return offerInfoSortingFuncHelper(offersMap[firstOfferId] || null, offersMap[secondOfferId] || null);
    });
    const keyMap = {
      starterOfferIds: STARTER,
      professionalOfferIds: PROFESSIONAL,
      enterpriseOfferIds: ENTERPRISE
    };
    const crmSuiteOfferIds = {};
    if (data.crmSuiteOfferIds) {
      for (const [_keyName, crmSuiteOfferId] of Object.entries(data.crmSuiteOfferIds)) {
        const keyName = _keyName;
        const {
          productOfferIds,
          quantityPackOfferIdsBySkuUuid,
          seatsOfferIds
        } = crmSuiteOfferId;
        const sortedProductOfferIds = getSortedOfferIds(productOfferIds);
        const sortedSeatOfferIds = getSortedOfferIds(seatsOfferIds);
        const sortedQuantityPackOfferIds = {};
        for (const [_apiName, skuUuidObj] of Object.entries(quantityPackOfferIdsBySkuUuid)) {
          const apiName = _apiName;
          const sortedOfferIds = {};
          for (const [skuUuid, offerIds] of Object.entries(skuUuidObj)) {
            sortedOfferIds[skuUuid] = getSortedOfferIds(offerIds);
          }
          sortedQuantityPackOfferIds[apiName] = sortedOfferIds;
        }
        crmSuiteOfferIds[keyMap[keyName]] = {
          productOfferIds: sortedProductOfferIds,
          quantityPackOfferIdsBySkuUuid: sortedQuantityPackOfferIds,
          seatsOfferIds: sortedSeatOfferIds
        };
      }
    }
    return Object.assign({}, data, {
      offersById: offersMap,
      crmSuiteOfferIds
    });
  }
  return data;
};